/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import styled from 'styled-components'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Form as NXUIForm } from '@nexigendigital/nxui'
import { toggleAutoRenew } from 'store/slices/shopSlice'
import { useAppDispatch } from 'store/hooks'

/**********************************************************************************************************
 *   INTERFACE
 **********************************************************************************************************/
interface Props {
    id: number,
    premium: boolean,
    domainName: string,
    addedItem: undefined | {
        auto_renew?: boolean | undefined
    }
}

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function AutoRenewToggle({ id, premium, domainName, addedItem }: Props) {
    const dispatch = useAppDispatch()

    function checkAutoRenew() {
        if (!addedItem) {
            return false
        }

        return Boolean(addedItem.auto_renew)
    }

    if (!premium) {
        return (
            <Toggle>
                <NXUIForm.Switch
                    checked={checkAutoRenew()}
                    disabled={!addedItem}
                    onClick={() => dispatch(toggleAutoRenew({
                        product_id: id,
                        name: domainName,
                        auto_renew: checkAutoRenew()
                    }))}
                />
            </Toggle>
        )
    }

    return null
}

/**********************************************************************************************************
 *   CUSTOM STYLING
 **********************************************************************************************************/
const Toggle = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`
